import { useAppSelector } from "app/hooks";
import Col from "react-bootstrap/Col";
import { selectStreamSlots } from "features/streamLayout/layoutSlice";
import useDragNDrop from "../useDragHooks";
import "./quadbox.css";

export function Quadbox() {
  const currentSlots = useAppSelector(selectStreamSlots);
  const { onDragOver, onDragLeave, onDrop } = useDragNDrop();

  let slotNames = currentSlots.map((slot) => (slot ? slot : "-"));

  return (
    <Col className="stream-chooser ratio ratio-16x9">
      <div>
        <div
          className="quadbox-tl"
          onDragOver={(ev) => onDragOver(ev)}
          onDrop={(ev) => onDrop(ev, 0)}
          onDragLeave={(ev) => onDragLeave(ev)}
        >
          {slotNames[0]}
        </div>
        <div
          className="quadbox-tr"
          onDragOver={(ev) => onDragOver(ev)}
          onDrop={(ev) => onDrop(ev, 1)}
          onDragLeave={(ev) => onDragLeave(ev)}
        >
          {slotNames[1]}
        </div>
        <div
          className="quadbox-bl"
          onDragOver={(ev) => onDragOver(ev)}
          onDrop={(ev) => onDrop(ev, 3)}
          onDragLeave={(ev) => onDragLeave(ev)}
        >
          {slotNames[3]}
        </div>
        <div
          className="quadbox-br"
          onDragOver={(ev) => onDragOver(ev)}
          onDrop={(ev) => onDrop(ev, 2)}
          onDragLeave={(ev) => onDragLeave(ev)}
        >
          {slotNames[2]}
        </div>
      </div>
    </Col>
  );
}
